$(document).ready(function () {
  let $regisrationSubmitButton = $("#user-registration-submit");
  let $updateSubmitButton = $("#userUpdateSubmit")
  let $distributorCodeField = $("#user_linked_distributor_code");
  let $acceptDistributorModal = $("#acceptDistributorModal");

  $regisrationSubmitButton.on("click", e => {
    let distributorCode = $distributorCodeField.val();

    if (
      distributorCode === "" ||
        $("#user_civility").val() === "" ||
        $("#user_first_name").val() === "" ||
        $("#user_last_name").val() === "" ||
        $("#user_email").val() === "" ||
        $("#user_password").val() === "" ||
        $("#user_password_confirmation").val() === "" ||
        $("#user_accepts_stock_illiquidity")[0].checked === false ||
        $("#user_accepts_capital_loss")[0].checked === false ||
        $("#user_terms_accepted")[0].checked === false
    ) {
      return;
    }

    e.preventDefault();

    launchAcceptDistributorModal($distributorCodeField, distributorCode, $acceptDistributorModal);
  });

  $updateSubmitButton.on("click", e => {
    let distributorCode = $distributorCodeField.val() || "";

    if (
      distributorCode === "" ||
        $("#user_accepts_stock_illiquidity")[0].checked === false ||
        $("#user_accepts_capital_loss")[0].checked === false ||
        $("#user_terms_accepted")[0].checked === false
    ) {
      return;
    }

    e.preventDefault();

    launchAcceptDistributorModal($distributorCodeField, distributorCode, $acceptDistributorModal);
  });
});

const launchAcceptDistributorModal = (distributorCodeField, distributorCode, modal) => {
  Rails.ajax({
    type: "POST",
    url: distributorCodeField.data("url"),
    data: `user[linked_distributor_code]=${distributorCode}`,
    dataType: "json",
    success: function(response) {
      if (response.no_distributor === true) {
        distributorCodeField.addClass("is-invalid");
      } else {
        distributorCodeField.removeClass("is-invalid");
        $("#distributorName").html(response.distributor);
        modal.modal("show");
      }
    },
    error: function(response) {
      document.getElementById("fields_errors").innerHTML = "Une erreur s'est produite, veuillez réessayer.";
    }
  });
}
